module.exports = __webpack_public_path__ + "static/03-thumb-6eb1c2594ca0815e45169c0bb3b32da5.jpg";